// src/pages/TrophyRoomPage.jsx
import React, { useState, useEffect } from 'react';
import { fetchStudentProfileBadges } from '../api/studentApi';
import StudentHeader from '../components/StudentHeader';
import StudentTrophyRoom from '../components/StudentTrophyRoom'; // 🌟 Reusing your component!
import LoadingSpinner from '../components/LoadingSpinner';
import './TrophyRoomPage.css';
import StudentHeaderV2 from '../components/StudentHeaderV2';

export default function TrophyRoomPage() {
  const [badgesData, setBadgesData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTrophies = async () => {
      try {
        const response = await fetchStudentProfileBadges();
        setBadgesData(response.data);
      } catch (err) {
        console.error("Failed to load achievements inventory matrix:", err);
      } finally {
        setLoading(false);
      }
    };
    loadTrophies();
  }, []);


  return (
    <div className="trophy-room-page-wrapper">
      <StudentHeaderV2/>

      <main className="trophy-room-main-content">
        {loading ? (
          <div className="loading-overlay">
            <LoadingSpinner message="Loading your achievements..." />
          </div>
        ) : (<>
          {/* Dynamic Header Frame */}
          <header className="trophy-page-banner">
            <div className="banner-title-block">
              <span className="banner-icon-emblem">🏆</span>
              <div>
                <h1>Achievements & Milestones</h1>
                <p>Review earned tokens, stellar performance indices, and cosmic exploration badges.</p>
              </div>
            </div>
            {badgesData?.points !== undefined && (
              <div className="score-counter-card">
                <span className="score-label-badges">Total Score</span>
                <strong className="score-number-badges">{badgesData.points} XP</strong>
              </div>
            )}
          </header>

          {/* 🌟 REUSING COMPONENT HERE */}
          <div className="trophy-component-injection-zone">
            <StudentTrophyRoom badgeInventory={badgesData?.badges || []} />
          </div>
        </>)}

      </main>
    </div>
  );
}